import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// @mui
import {
  Alert, 
  Card, Container, Grid, CardContent, Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Stack
} from '@mui/material';
// components
import { AddVideoForm } from 'src/sections/@dashboard/student';
import Iconify from '../../components/iconify';

// ----------------------------------------------------------------------

const getYouTubeID = (url) => {
  if (!url) return '';
  if (!url.includes('/') && url.length === 11) return url;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : url;
};

export default function MediaPage() {
  const [videos, setVideos] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const getVideos = () => {
    setIsOpen(false)
    api.get(`video-api?filter[type]=2&filter[student_id]=${profile.data.id}`)
      .then((result) => {
        setVideos(result);
      })
      .catch(() => {
        setVideos([]);
      });
  }

  useEffect(() => {
    getVideos()
  }, [])

  return (
    <>
      <Helmet>
        <title> Мої медіа | Lala English </title>
      </Helmet>

      <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Сюди можеш додавати свої відео з YouTube.</Alert>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Button onClick={() => setIsOpen(true)} variant="outlined" startIcon={<Iconify icon="eva:plus-fill" />}>Додати відео</Button>
        </Stack>
        <Dialog onClose={() => setIsOpen(false)} open={isOpen}>
          <DialogTitle>
            {" "}
            <Typography>Додати відео</Typography>
          </DialogTitle>
          <DialogContent>
            <AddVideoForm success={getVideos} />
          </DialogContent>
        </Dialog>
        <Grid container spacing={3}>
          {videos.map((video) => (
            <Grid key={video.id} item xs={12} sm={6} md={4}>
              <Card sx={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                  <iframe
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    src={`https://www.youtube.com/embed/${getYouTubeID(video.url)}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>

                <CardContent sx={{ pt: 2, flexGrow: 1 }}>
                  <Typography variant="subtitle2">{video.title}</Typography>
                  {video.text ? <Typography variant="body2" sx={{ pt: 2 }}>{video.text}</Typography> : null}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}